@if (!hasSousMenu()) {
  <a (click)="performMenuAction()" class="menu_topbar_first-level" href="">
    <i [ngClass]="menuItem.iconClass" class="icon"></i>
  </a>
} @else {
  <div class="menu_topbar_first-level" (click)="switchSousMenuOpen()" routerLinkActive="is-active" [ngClass]="{'is-expanded':isSousmenuOpen}">
    <i [ngClass]="menuItem.iconClass" class="icon"></i>
  </div>
  @if (isSousmenuOpen) {
    <div class="menu_topbar_second-level" appClickOutside (clickOutside)="hideSousMenu()">
      <ul>
        @for (sousMenuItem of menuItem.sousMenu; track sousMenuItem) {
          <li>
            @if (!sousMenuItem.isOutsideLink) {
              <a [routerLink]="sousMenuItem.routerLink" href=""
                (click)="hideSousMenu()" routerLinkActive="is-active"
                [ngClass]="{'purechat-button-expand': sousMenuItem.libelle == 'Live chat'}">
                <i class="icon {{sousMenuItem.iconClass}}"></i>
                <span>{{sousMenuItem.libelle}}</span>
              </a>
            } @else {
              <a [href]="sousMenuItem.routerLink" target="_blank">
                <i class="icon {{sousMenuItem.iconClass}}"></i>
                <span [title]="sousMenuItem.routerLink">{{sousMenuItem.libelle}}</span>
              </a>
            }
          </li>
        }
      </ul>
    </div>
  }
}

